import template from "./select-cost-modal.html";

const SelectCostModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class CostListViewController {
    /* @ngInject */
    constructor($rootScope, $q, $filter, ModalsManager, CostFolder, Cost) {
      this.$rootScope = $rootScope;
      this.$q = $q;
      this.$filter = $filter;
      this.ModalsManager = ModalsManager;
      this.CostFolder = CostFolder;
      this.Cost = Cost;
    }

    async $onInit() {
      this.rootFolder = {
        _id: null,
        name: this.$filter("trans")("costFolder.main"),
      };
      this.parentCostFolder = {};
      this.folders = [];
      this.costs = [];
      this.costsCount = 0;
      this.searchOptions = {
        name: "",
        page: 1,
      };

      await this.refresh(this.rootFolder);
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.name,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            if (newVal.length === 0) this.refresh(this.rootFolder).then();
            else this.findBySearchText().then();
          }
        },
      );
    }

    selectCost(cost) {
      this.close({ $value: cost });
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }

    async findBySearchText() {
      this.loading = true;
      this.searchOptions.page = 1;
      const data = await this.$q
        .all({
          costFolderPromise: this.CostFolder.query({
            q: this.searchOptions.name,
          }),
          costPromise: this.Cost.query({
            q: this.searchOptions.name,
            page: this.searchOptions.page,
          }),
          costsCountPromise: this.Cost.getCount({ q: this.searchOptions.name }),
        })
        .then((values) => {
          return {
            folders: values.costFolderPromise,
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.folders = data.folders;
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async refresh(parent) {
      this.loading = true;
      const data = await this.$q
        .all({
          costFolderPromise: this.CostFolder.queryByParent(parent._id),
          costPromise: this.Cost.queryByParent(parent._id, this.searchOptions.page),
          costsCountPromise: this.Cost.getCount({
            parent: parent._id || "null",
          }),
        })
        .then((values) => {
          return {
            folders: values.costFolderPromise,
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.parentCostFolder = parent;
      this.folders = data.folders;
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async loadMoreCosts() {
      const loadedCosts = this.costs.length;
      const costsToLoad = this.costsCount;
      if (loadedCosts < costsToLoad && !this.loading) {
        this.searchOptions.page++;
        const costs = await this.loadCosts();
        this.costs = this.costs.concat(costs);
        this.$rootScope.$applyAsync();
      }
    }

    async loadCosts() {
      this.loading = true;
      let costs = [];

      if (this.searchOptions.name === "")
        costs = await this.Cost.queryByParent(this.parentCostFolder._id, this.searchOptions.page);
      else
        costs = await this.Cost.query({
          q: this.searchOptions.name,
          page: this.searchOptions.page,
        });

      this.loading = false;
      this.$rootScope.$applyAsync();
      return costs;
    }

    async loadCostFolder(parentCostFolderId) {
      if (parentCostFolderId) {
        const parentCostFolder = await this.CostFolder.get(parentCostFolderId);
        await this.refresh(parentCostFolder);
        this.parentCostFolder = parentCostFolder;
      } else {
        await this.refresh(this.rootFolder);
      }
      this.$rootScope.$applyAsync();
    }

    async createCost() {
      if (await this.ModalsManager.openCostModal(new this.Cost({ parent: this.parentCostFolder._id }))) {
        await this.loadCostFolder(this.parentCostFolder._id);
      }
    }

    async createCostFolder() {
      if (await this.ModalsManager.openCostFolderModal(new this.CostFolder({ parent: this.parentCostFolder._id }))) {
        await this.loadCostFolder(this.parentCostFolder._id);
      }
    }
  },
};

export default SelectCostModalComponent;
